import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { SignInDataType } from '../../../models/auth/signIn.model';
import { ErrorHttpResponse, HttpConfig } from '../../../models/https';
import useHttps from '../../useHttps';
import useSetAuthentication from '../useSetAuthentication';

const useSignin = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [signInError, setSignInError] = useState(null);
  const { setAuthentication } = useSetAuthentication();


  const onSignInError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(err?.response?.data?.message ?? 'Something went wrong');
    setSignInError(err?.response?.data?.message ?? 'Something went wrong');
  };

  const signin = (data: SignInDataType) => {
    const url: HttpConfig = {
      url: 'ba/v1/auth/login',
      method: 'post',
      data
    };

    request(url, setAuthentication, setLoading, onSignInError);
  };

  return {
    loading,
    signin,
    signInError,
  };
};

export default useSignin;
